// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jX-l","comment":"styles_comment__xUfv_"};